import axios from 'axios'
axios.defaults.headers['Cache-Control'] = 'no-cache';

let fetchCache = {}
export default {
    data() {
        return {

        }
    },
    components: {},
    methods: {
        /**
         * 一个方法：请求接口
         * ...
         * @param {boolean} useCache （可选）是否使用缓存，true时，请求会先返回一个缓存数据，等待数据请求到之后，会重新发新的数据
         * @param {boolean} onlyCache （可选）是否仅使用缓存，true时，请求会优先查询缓存，等新数据请求到之后，只是更新之前的缓存数据
         * ...
         */
        $axios(option) {
            let self = this
            let _url = option.url //.split('?')[0]
            // if (!(option.headers && option.headers['Cache-Control'])) {
            //     if (option.headers) {
            //         option.headers['Cache-Control'] = 'no-cache'
            //     } else {
            //         option.headers = {}
            //         option.headers['Cache-Control'] = 'no-cache'
            //     }
                
            // }
            return {
                then(call) {
                    if (option.useCache || option.onlyCache) {
                        if (fetchCache[_url]) {
                            call && call(fetchCache[_url], true)
                        }
                    }
                    return axios(option).then(res => {
                        if (option.onlyCache) {
                            if (!fetchCache[_url]) {
                                call && call(res, false)
                            }
                            fetchCache[_url] = res
                            return
                        }
                        if (option.useCache) {
                            fetchCache[_url] = res
                        }
                        call && call(res, false)
                    })
                }
            }
        }
    }
}